<template>
<div >
  <common ref="common" />
    <v-toolbar
          dark
          color="primary"
        >
          <v-toolbar-title>Privacy Policy</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
            icon
            dark
            @click="closeDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          </v-toolbar-items>
    </v-toolbar>
  <v-sheet >
    <div  class=" h-100 mx-6 py-5 pb-10">
      <div>     This Policy will be revised from time to time. A member's use of www.kvveswesupport.com
             services after changes to the Policy are posted on www.kvveswesupport.com app,
              www.kvveswesupport.com, will constitute the customer's acceptance of any new or additional 
              terms of the Policy that result from those changes.
      </div>

      <div class="d-flex pt-5">
        <h3>Sharing of Information</h3>
      </div>
      <div class="pt-2"> We will not sell, share, or rent this information to others in ways different from what is disclosed in this statement.
      </div>

      <div class="d-flex pt-5">
        <h3>Registration of Contact Details</h3>
      </div>
      <div class="pt-2"> Some forms on this website request contact information (such as name, email address, telephone). This information is used to contact our member regarding services on our site for which they have expressed interest. We do not collect or retain credit card information as this is handled by our secure third party payment processor.
      </div>

      <div class="d-flex pt-5">
        <h3>Sharing of Customer Contact Information</h3>
      </div>
      <div class="pt-2"> We use a third party payment processing organisation to accept payment for products and services. Credit card details are collected for order processing only. Our third party payment processor organisation does not retain, share, store or use personally identifiable information for any secondary purposes. When a customer requests a specific service which has been agreed, we will share names, or other contact information that are necessary for the third party to provide these services (for example: We may pass your contact information for the purpose of ordering a dedicated server and licences). These parties are not allowed to use personally identifiable information except for the purpose of providing these services.
      </div>

      <div class="d-flex pt-5">
        <h3>Third-party URLs in our Website</h3>
      </div>
      <div> This web site may contain links to other sites. Please be aware that we are not responsible for the privacy practices of such other sites. We encourage our customers to be aware when they leave our site and to read the privacy statements of each and every web site that collects personally identifiable information. This privacy statement applies solely to information collected by this website.
      </div>

      <div class="d-flex pt-5">
        <h3>Log files</h3>
      </div>
      <div class="pt-2"> We use IP addresses to research trends (this assists in identifying which states and countries our customers come from for the purpose of statistics), administer the site, and gather broad demographic information for aggregate use. IP addresses are not linked to personally identifiable information
      </div>

      <div class="d-flex pt-5">
        <h3>Opt-Out of service</h3>
      </div>
      <div class="pt-2"> Our members are given the opportunity to 'opt-out' of services provided by us any time. We refund balance payments as per the terms agreed at the time of joining
      </div>

      <div class="d-flex pt-5">
        <h3>Minor Policy</h3>
      </div>
      <div class="pt-2"> The content of this app is provided by the Society to its registered members who can access the information with their user ID and Password. Every Family Head (Member) is provided with a user ID and password who will access the app for all family members. The information provided in the app comply with the rules and regulations that apply to Minors and Family.
      </div>

      <div class="d-flex pt-5">
        <h3>Updates to Privacy Policy</h3>
      </div>
      <div class="pt-2"> From time to time our privacy policy is updated. Update notification will be posted on our website to ensure customers are aware of changes which may affect them. We will not use personal information for any other purpose or and other terms already specified on this website without notifying our customers in writing first
      </div>
    </div>
  </v-sheet>
</div>
</template>
<script>
export default {
  components: {
    common: () => import("@/components/tools/common.vue"),
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
      this.$emit("update:privacyPolicy", false);
    },
  },
};
</script>
<style>
.overflow-80 {
  max-height: 80vh;
  overflow: auto;
}
</style>